import useScript from '@local/useScript'

const RECAPTCHA_BASE_URL = 'https://www.google.com/recaptcha/api.js'
const createRecaptchaRenderUrl = (recaptchaKeyArg: string) => {
  return `${RECAPTCHA_BASE_URL}?render=${recaptchaKeyArg}`
}

/**
 *
 * @param recaptchaKey - Public-facing key for Google ReCAPTCHA account
 * @param recaptchActionId
 * @returns {string} a ReCAPTCHA token to be put through to backend request
 * @throws {Error} some opaque error from Google's ReCAPTCHA service
 */
export const getRecaptchaToken = (
  recaptchaKey: string,
  recaptchActionId: string
) => {
  return new Promise<string>(async (res, rej) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(recaptchaKey, {
          action: recaptchActionId
        })
        .then(
          (value) => res(value),
          // Cannot use `catch`, as this uses a then(success, reject) 'promise-like' interface
          (rejectionReason) => {
            rej(rejectionReason)
          }
        )
    })
  })
}

export const useSetupRecaptcha = (
  recaptchaKey: string,
  recaptchaEnabled: boolean = true
) => {
  return useScript(createRecaptchaRenderUrl(recaptchaKey), {
    shouldPreventLoad: !recaptchaEnabled
  })
}
